/*!
 * c-tabs — ARIA-compliant tab list custom element.
 *
 * USAGE
 *   <c-tabs>
 *     <div role="tablist">
 *       <button role="tab" aria-controls="panel-a" aria-selected="true">A</button>
 *       <button role="tab" aria-controls="panel-b">B</button>
 *     </div>
 *     <div id="panel-a" role="tabpanel">…</div>
 *     <div id="panel-b" role="tabpanel" hidden>…</div>
 *   </c-tabs>
 *
 * The first tab with aria-selected="true" wins on init. If none are selected,
 * the first tab is auto-selected.
 */
(function () {
  if (window.customElements && customElements.get('c-tabs')) return;

  class CTabs extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      const tabs = this.querySelectorAll('[role="tab"]');
      if (!tabs.length) return;
      this.tabs = Array.from(tabs);
      this.panels = this.tabs.map(t => document.getElementById(t.getAttribute('aria-controls'))).filter(Boolean);
      // Find or set initial active tab
      let active = this.tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
      if (active < 0) active = 0;
      this._select(active);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this._select(i));
        tab.addEventListener('keydown', (e) => this._onKey(e, i));
      });
    }

    _select(idx) {
      this.tabs.forEach((tab, i) => {
        const selected = i === idx;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        tab.classList.toggle('is-active', selected);
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== idx;
        panel.classList.toggle('is-active', i === idx);
      });
      this.dispatchEvent(new CustomEvent('tabchange', { detail: { index: idx } }));
    }

    _onKey(e, i) {
      const last = this.tabs.length - 1;
      let next = -1;
      if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      if (next < 0) return;
      e.preventDefault();
      this._select(next);
      this.tabs[next].focus();
    }
  }
  customElements.define('c-tabs', CTabs);
})();
